import { useTranslation } from 'react-i18next'

// Leading "Overdue" label for a date/recurrence segment in a row's meta line;
// inherits the segment's red text colour.
export function OverdueSegment() {
  const { t } = useTranslation()
  return <span className="pr-1 font-semibold shrink-0">{t('inbox.overdue')}</span>
}
